import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { signInForCourseBundle } from 'src/common/services/courseBundle';
import { snackbarActions } from 'src/state/notification/notificationActions';

export const useCourseBundleSignInMutation = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation((courseBundleId: number) => signInForCourseBundle(courseBundleId), {
    onSuccess: () => {
      dispatch(
        snackbarActions.enqueueSnackbar({
          key: 'course-bundle-sign-in-success',
          message: 'Zapisałeś się na kurs',
          options: {
            variant: 'success',
          },
        }),
      );
      queryClient.invalidateQueries(QueryKey.UserCourseBundleEnrollmentStatus);
    },
  });
};
